import { InputText, useInputTextContext } from '../../input-text'
import type {
  InputTextActionsProps,
  InputTextScopedProps,
} from '../../input-text.types'
import { renderCompositionChildren } from '../../utils/render-composition-children'
import { inputTextActionsVariants } from './index.styles'

export const InputTextActions = ({
  children,
  __scopeInputText,
  ...props
}: InputTextScopedProps<InputTextActionsProps>) => {
  const { disabled, hasError, readOnly, size } = useInputTextContext(
    'InputTextActions',
    __scopeInputText
  )

  return (
    <div
      {...props}
      className={inputTextActionsVariants({
        size,
        disabled,
        readOnly,
        hasError,
      })}
      aria-disabled={disabled}
      data-disabled={disabled}
    >
      {renderCompositionChildren(children, [
        { child: InputText.Icon, amount: 2 },
        { child: InputText.Field, amount: 1 },
        { child: InputText.ClearButton, amount: 1 },
      ])}
    </div>
  )
}
